import { Auth, User, getAuth, onIdTokenChanged } from 'firebase/auth';
import { getFirebaseApp, isFirebaseConfigured } from './config';

const getFirebaseAuth = (): Auth => getAuth(getFirebaseApp());

const getCurrentUserIdToken = async (forceRefresh: boolean = false): Promise<string | null> => {
  if (!isFirebaseConfigured) {
    return null;
  }

  const auth = getFirebaseAuth();
  const currentUser = auth.currentUser;

  if (!currentUser) {
    return null;
  }

  return currentUser.getIdToken(forceRefresh);
};

const listenToIdTokenChanges = (callback: (user: User | null) => void) => {
  if (!isFirebaseConfigured) {
    callback(null);
    return () => {};
  }

  const auth = getFirebaseAuth();
  return onIdTokenChanged(auth, callback);
};

const getCurrentUserEmail = (): string | null => {
  if (!isFirebaseConfigured) {
    return null;
  }

  return getFirebaseAuth().currentUser?.email ?? null;
};

const getCurrentUserUid = (): string | null => {
  if (!isFirebaseConfigured) {
    return null;
  }

  return getFirebaseAuth().currentUser?.uid ?? null;
};

export { getFirebaseAuth, getCurrentUserIdToken, listenToIdTokenChanges, getCurrentUserUid, getCurrentUserEmail };
